var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommend-list"},_vm._l((_vm.recommendList),function(item,index){return _c('RecommendItem',{key:index,attrs:{"recommendItem":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }